import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { organizationListContext } from 'BrokerTsLib/src/context'
import type {
  OrganizationUnitGridItem,
  OrganizationUnitPagedQuery,
} from 'BrokerTsLib/src/dtos'
import { useGetAll } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useState } from 'react'

import { Add } from '../../icons'
import {
  OrganizationListCityColumn,
  OrganizationListDescriptionColumn,
  OrganizationListNameColumn,
  OrganizationListTypeColumn,
  OrganizationListValidColumn,
  OrganizationsList,
} from '../organization/OrganizationList'
import { OrganizationListFilter } from '../organization/OrganizationListFilter'
import { Pagination } from '../Pagination'
import { AddButton } from './AddButton'

const pageSize = 15
export const AddFlexGroupOrganization = ({
  onAddMember,
  alreadyAdded,
}: {
  onAddMember: (organizationUnitId: number, includeSubordinate: boolean) => Promise<any>
  alreadyAdded: OrganizationUnitGridItem[]
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [filter, setFilter] = useState<OrganizationUnitPagedQuery>({
    showInvalid: false,
    showRootOnly: false,
    pageIndex: 1,
    pageSize,
  })

  const { data, refetch, isLoading } = useGetAll(filter, { enabled: isOpen })

  const organizations = data?.data.items ?? []

  return (
    <Box>
      <Button
        colorScheme="primary"
        variant="link"
        onClick={() => onOpen()}
        whiteSpace="nowrap"
      >
        <Add /> Přidat organizaci
      </Button>
      <Modal size="4xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>
            <Text>Přidat organizaci</Text>
            <ModalCloseButton />
          </ModalHeader>

          <ModalBody sx={{ pt: 0, pb: 6, gap: 4 }}>
            <organizationListContext.Provider
              value={{
                loading: isLoading,
                totalCount: data?.data.totalCount ?? 0,
                currentPage: filter.pageIndex,
                pageSize,
                filter,
                setCurrentPage: (p) => setFilter(f => ({ ...f, pageIndex: p })),
                setPageSize: () => { },
                updateFilter: setFilter,
                reload: () => refetch(),
              }}
            >
              <Flex flexDir={'column'} gap={4}>
                <OrganizationListFilter />
                <OrganizationsList
                  organizations={organizations}
                  sx={{ boxShadow: 'none' }}
                  columnsDefinition={[
                    {
                      key: 'actions',
                      name: '',
                      cellExpr: (item) => (
                        <AddButton
                          alreadyAdded={alreadyAdded.some((x) => x.id === item.id)}
                          onClick={() => onAddMember(item.id, false)} />
                      ),
                      cellProps: { p: 0, px: 2 },
                    },
                    OrganizationListNameColumn,
                    OrganizationListCityColumn,
                    OrganizationListDescriptionColumn,
                    OrganizationListValidColumn,
                    OrganizationListTypeColumn,
                  ]}
                />
                <Pagination context={organizationListContext} />
              </Flex>
            </organizationListContext.Provider>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  )
}
